var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYandexIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.23346 1.58356C7.08773 2.05143 5.79091 3.72878 5.56229 6.33207C5.38103 8.39596 6.05957 10.0822 7.47884 11.095L7.87976 11.3811L7.61492 11.8598C5.12858 16.3539 5.00025 16.5977 5 16.8266C4.99981 16.9966 5.04949 17.116 5.18232 17.2646L5.36489 17.469H6.39731C7.39687 17.469 7.43479 17.4643 7.58733 17.3209C7.67398 17.2395 8.34495 15.9941 9.07836 14.5534C10.0644 12.6163 10.4403 11.9336 10.5213 11.9329C10.6238 11.9319 10.6308 12.0965 10.6321 14.5127C10.6334 16.8636 10.6432 17.1054 10.7416 17.227C10.9306 17.4603 11.0973 17.5002 11.8811 17.5002C12.6823 17.5002 12.9392 17.4333 13.069 17.1909C13.1122 17.1102 13.1334 14.5717 13.1334 9.49682V1.92311L12.951 1.71876L12.7685 1.51442L11.2148 1.50234C10.0341 1.49321 9.55831 1.51273 9.23346 1.58356ZM10.5995 6.70747V9.64811L10.2241 9.63128C8.95028 9.57422 8.27875 8.69465 8.20686 6.98902C8.11896 4.90241 8.91305 3.70463 10.3492 3.75763L10.5995 3.76683V6.70747Z",
    fill: "#5E5873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexIcon);
export default __webpack_public_path__ + "static/media/yandexIcon.d757d6e7ecdd16153cc81becc8ff51ae.svg";
export { ForwardRef as ReactComponent };